<template>
  <div>
    <google-map-loader
    :mapConfig="configuracionMapa">
    <template slot-scope="{ google, map }">
      <!-- En caso de marcadores -->
      <GoogleMapMarker
        v-for="marcador in marcadores"
        :key="marcador.id"
        :marcador.sync="marcador"
        :google="google"
        :map="map"
      />
      <!-- En caso de polilineas -->
      <GoogleMapLine
        v-for="linea in lineas"
        :key="linea.id"
        :linea.sync="linea"
        :google="google"
        :map="map"
      />
    </template>
  </google-map-loader>
  </div>
</template>

<script>
import GoogleMapLoader from './GoogleMapLoader.vue';
import GoogleMapMarker from './GoogleMapMarker.vue';
import GoogleMapLine from './GoogleMapLine.vue';

export default {
  name: 'GoogleMap',
  props: {
    marcadores: {
      type: Array,
      required: false,
    },
    lineas: {
      type: Array,
      required: false,
    },
  },
  components: {
    GoogleMapLoader,
    GoogleMapMarker,
    GoogleMapLine,
  },
  data() {
    return {
      configuracionMapa: {
        mapId: '1be35265b1e78c09',
        center: {
          lat: 29.094019,
          lng: -110.992415,
        },
        zoom: 13,
      },
    };
  },

};
</script>

<style>

</style>
